<template>
	<footer class="footer">
		<div class="container">
			<!-- 2x2 网格布局 -->
			<div class="footer-grid">
				<!-- 左上：品牌名称 -->
				<div class="footer-grid-item footer-logo">
					<span class="footer-brand-name">科峰纵横</span>
				</div>

				<!-- 右上：客服热线 -->
				<div class="footer-grid-item footer-contact">
					<!-- <div class="footer-hotline">
						<svg class="hotline-icon" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="1.5">
							<path d="M4 12V10a8 8 0 0 1 16 0v2" />
							<rect x="2" y="10" width="4" height="6" rx="1" />
							<rect x="18" y="10" width="4" height="6" rx="1" />
							<path d="M12 18v2" />
							<path d="M9 20h6" />
						</svg>
						<div class="hotline-content">
							<span class="hotline-label">客服热线：</span>
							<span class="hotline-number">{{ contactInfo.phone }}</span>
						</div>
					</div> -->
				</div>

				<!-- 左下：核心技术链接 -->
				<div class="footer-grid-item footer-links">
					<div class="link-column" v-for="(col, idx) in footerLinks" :key="idx">
						<h5 class="link-title">{{ col.title }}</h5>
						<ul class="link-list">
							<li v-for="(link, i) in col.links" :key="i">{{ link }}</li>
						</ul>
					</div>
				</div>

				<!-- 右下：二维码和联系方式 -->
				<div class="footer-grid-item footer-qr">
					<div class="footer-contact-info">
						<div class="contact-item">
							<svg class="contact-icon" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="1.5">
								<rect x="2" y="4" width="20" height="16" rx="2" />
								<path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
							</svg>
							<div class="contact-text-block">
								<span class="contact-label-bold">公司邮箱：</span>
							</div>
						</div>
						<span class="contact-value-wrap">{{ contactInfo.email }}</span>
						<div class="contact-item" style="margin-top: 20px;">
							<svg class="contact-icon" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="1.5">
								<path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
								<circle cx="12" cy="10" r="3" />
							</svg>
							<div class="contact-text-block">
								<span class="contact-label">公司地址：</span>
								
							</div>
						</div>
						<span class="contact-value-wrap">{{ contactInfo.address }}</span>
						<div class="qr-code">
							<img v-if="qrCodeImageUrl" :src="qrCodeImageUrl" alt="二维码">
							<div v-else class="qr-placeholder">QR</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 底部版权 -->
			<div class="footer-bottom">
				<div class="footer-bottom-left">
					<p>
						{{ contactInfo.copyright || contactInfo.companyName + ' All rights reserved. ' }}
						网站备案号:{{ contactInfo.icp }}
					</p>
				</div>
				<div class="footer-bottom-right">
					<a href="#">网站地图</a>
					<span class="divider">|</span>
					<a href="#">隐私条款</a>
					<span class="divider">|</span>
					<a href="#">法律申明</a>
				</div>
			</div>
		</div>
	</footer>
</template>
<script setup>
	import {
		ref,
		onMounted,
		computed
	} from 'vue'
	import {
		getFooterTree,
		getContact
	} from '@/api/website'

	const contactInfo = ref({
		phone: '111-1111-111',
		email: 'san@san.com',
		address: '上海市浦东新区张江高科技园区',
		qrCodeUrl: '',
		companyName: '',
		copyright: '',
		icp: ''
	})

	const footerLinks = ref([])

	// 获取完整图片 URL
	const getFullImageUrl = (url) => {
		if (!url) return ''
		if (url.startsWith('http')) return url
		return url // 若依通常配置了 baseURL 或 proxy，这里直接用相对路径
	}

	const qrCodeImageUrl = computed(() => {
		return getFullImageUrl(contactInfo.value.qrCodeUrl)
	})

	// 加载页脚数据
	const loadData = async () => {
		try {
			const [footerRes, contactRes] = await Promise.all([getFooterTree(), getContact()])

			if (footerRes.code === 200 && footerRes.data) {
				footerLinks.value = footerRes.data.map(footer => ({
					title: footer.footerName,
					links: footer.children ? footer.children.map(child => child.footerName) : []
				}))
			}

			if (contactRes.code === 200 && contactRes.rows?.length > 0) {
				const contact = contactRes.rows[0]
				contactInfo.value = {
					phone: contact.hotline || contact.phone || '111-1111-111',
					email: contact.email || 'san@san.com',
					address: contact.address || '上海市浦东新区张江高科技园区',
					qrCodeUrl: contact.qrCodeUrl || '',
					companyName: contact.companyName || '',
					copyright: contact.copyright || '',
					icp: contact.icp || ''
				}
			}
		} catch (error) {
			console.error('加载页脚数据失败:', error)
		}
	}

	onMounted(() => {
		loadData()
	})
</script>
<style scoped>
	.footer {
		background: #fff;
		color: #333;
		padding: 30px 0 20px;
	}

	.footer .container {
		max-width: 1400px;
		margin: 0 auto;
		padding: 0 60px;
	}

	/* 2x2 网格布局 */
	.footer-grid {
		display: grid;
		grid-template-columns: 3fr 1fr;
		grid-template-rows: 140px auto;
		gap: 0 0;
		margin-bottom: 0;
		position: relative;
	}

	/* 分割线 */
	.footer-grid::before {
		content: '';
		position: absolute;
		left: 0;
		right: 0;
		top: 140px;
		height: 1px;
		background: #e0e0e0;
	}

	.footer-grid::after {
		content: '';
		position: absolute;
		left: 75%;
		top: 0;
		bottom: 0;
		width: 1px;
		background: #e0e0e0;
	}

	.footer-grid-item {
		display: flex;
		padding: 0;
	}

	/* 左上 Logo */
	.footer-logo {
		align-items: center;
		height: 140px;
	}

	.footer-brand-name {
		font-size: 42px;
		font-weight: 700;
		color: #333;
		letter-spacing: 5px;
	}

	/* 右上 客服 */
	.footer-contact {
		align-items: center;
		justify-content: flex-start;
		height: 140px;
		padding-left: 36px;
	}

	.footer-hotline {
		display: flex;
		align-items: center;
		gap: 8px;
		font-size: 13px;
		color: #333;
	}

	.hotline-icon {
		width: 16px;
		height: 16px;
		flex-shrink: 0;
	}

	.hotline-content {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 4px;
	}

	.hotline-label {
		font-size: 13px;
		font-weight: 700;
		color: #333;
	}

	.hotline-number {
		font-size: 14px;
		font-weight: 700;
		color: #333;
		white-space: nowrap;
	}

	/* 左下 链接 */
	.footer-links {
		display: flex;
		gap: 80px;
		padding-top: 50px;
		padding-bottom: 50px;
	}

	.link-column {
		text-align: center;
	}

	.link-title {
		font-size: 16px;
		font-weight: 600;
		color: #333;
		margin-bottom: 18px;
	}

	.link-list {
		list-style: none;
	}

	.link-list li {
		font-size: 14px;
		color: #666;
		padding: 5px 0;
		cursor: pointer;
		transition: color 0.2s;
	}

	.link-list li:hover {
		color: #4a90e2;
	}

	/* 右下 二维码 */
	.footer-qr {
		justify-content: flex-start;
		align-items: flex-start;
		padding-top: 50px;
		padding-bottom: 50px;
		padding-left: 36px;
	}

	.footer-contact-info {
		display: flex;
		flex-direction: column;
		gap: 10px;
	}

	.contact-item {
		display: flex;
		align-items: flex-start;
		gap: 10px;
		font-size: 14px;
		color: #666;
	}

	.contact-icon {
		width: 26px;
		height: 26px;
		flex-shrink: 0;
		margin-top: 2px;
	}

	.contact-text-block {
		display: flex;
		flex-direction: column;
		gap: 4px;
	}

	.contact-label {
		font-size: 18px;
		font-weight: 550;
		color: #000;
	}

	.contact-label-bold {
		font-size: 18px;
		font-weight: 550;
		color: #000;
	}

	.contact-value-wrap {
		font-size: 16px;
		color: #000000;
		line-height: 1.4;
		word-break: break-all;
	}

	.qr-code {
		width: 120px;
		height: 120px;
		background: #f5f5f5;
		border-radius: 4px;
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 15px;
	}

	.qr-code img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.qr-placeholder {
		font-size: 15px;
		color: #999;
	}

	/* 版权底部 */
	.footer-bottom {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-top: 25px;
		border-top: 1px solid #eee;
		font-size: 16px;
		color: #000000;
	}

	.footer-bottom-left p {
		margin: 0;
	}

	.footer-bottom-right {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.footer-bottom-right a {
		color: #000;
		text-decoration: none;
		transition: color 0.2s;
	}

	.footer-bottom-right a:hover {
		color: #4a90e2;
	}

	.footer-bottom-right .divider {
		color: #ccc;
	}
</style>